import React from "react";
import Table from "react-bootstrap/Table";
import "./DetaljiTable.css";
import { PaperClipOutlined, ZoomInOutlined } from "@ant-design/icons";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const RevizorskaDrustvaDetaljiTable = (props) => {
  let drustvo;
  let adresaDrustva = [];
  let registracijaDrustva = [];
  let kontaktDrustva = [];
  let osobaDrustvo = [];
  let clanDrustva = [];
  let mreza = [];
  let clanMreze = [];
  let mjere = [];
  let povezaniSubjekti=[];

  let ovlasteniRevizori = [];
  let clanoviUprave = [];
  let dionicari = [];
  let odobrenjeZaRad = [];
  let registracijaNadlTijelaDrugihDrzavaCl = [];
  let regUDrugojDrzaviKaoSubjektaZaObavljanjeRevizijeUTrecojZemlji = [];

  let registar = props.children;

  drustvo = registar[1];
  adresaDrustva = registar[2];
  registracijaDrustva = registar[3];
  kontaktDrustva = registar[4];
  osobaDrustvo = registar[5];
  clanDrustva = registar[6];
  mreza = registar[7];
  clanMreze = registar[8];
  mjere = registar[10];
  povezaniSubjekti = registar[11];

  let adrDrustva = adresaDrustva.filter(
    (x) => x.vrAdr === 1 && x.sifDrzave == 191
  );
  let adrUreda = adresaDrustva.filter(
    (x) => x.vrAdr === 2 && x.sifDrzave == 191
  );

  odobrenjeZaRad = registracijaDrustva.filter((x) => x.vrRegistracije == 1);

  registracijaNadlTijelaDrugihDrzavaCl = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 2
  );
  regUDrugojDrzaviKaoSubjektaZaObavljanjeRevizijeUTrecojZemlji =
    registracijaDrustva.filter((x) => x.vrRegistracije == 3);
  let nadleznaTijela = registracijaDrustva.filter(
    (x) => x.vrRegistracije === 4
  );

  ovlasteniRevizori = osobaDrustvo.filter((x) => x.vrVeze == 1);

  clanoviUprave = clanDrustva.filter((x) => x.vrClana == 2);

  dionicari = clanDrustva.filter((x) => x.vrClana == 1);

  let clanoviMreze = clanMreze.filter((x) => x.vrClana === 1);
  let povezanaDrustva = clanMreze.filter((x) => x.vrClana === 2);

  const noDataMessage = "";

  const { userRole } = props;

  const checkIfUserIsAdmin = 
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <div id="printArea">
      {drustvo.napomena ? (
        <RazlogBrisanjaComponent razlog={drustvo.napomena} />
      ) : null}
      <h5>Pregled podataka</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Revizorsko društvo - naziv</th>
            <th scope="col">OIB</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Pravni oblik</th>
            <th scope="col">Broj i datum odobrenja za rad</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{drustvo.nazDrustva}</td>
            <td x-ms-format-detection="none">{drustvo.oib}</td>
            <td>{drustvo.regBroj}</td>
            <td>{drustvo.pravniOblik}</td>
            <td className="hr-divider">
              {odobrenjeZaRad.map((element) => (
                <>
                  <table>
                    {!element.brReg && !element.datReg ? (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Izdavatelj: </b>
                            Hrvatska revizorska komora
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {element.brReg}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {element.datReg}
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  <hr />{" "}
                </>
              ))}
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>Adrese</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Adresa sjedišta</th>
            <th scope="col">Adresa svakog ureda</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {adrDrustva.map((adrDrustvo, index) => (
              <td key={`tdDrustvo${index}`}>
                <table>
                  <tbody style={{ width: "100%" }}>
                    <tr>
                      <td className="inner-td">
                        <b>Ulica i kbr: </b>
                        {adrDrustvo.ulicaKbr
                          ? adrDrustvo.ulicaKbr
                          : noDataMessage}
                      </td>
                    </tr>
                    <tr>
                      <td className="inner-td">
                        {adrDrustvo.brPoste || adrDrustvo.nazNaselja ? (
                          <>
                            <b>Grad: </b>
                            {adrDrustvo.brPoste}
                            {adrDrustvo.nazNaselja &&
                              " " + adrDrustvo.nazNaselja}
                          </>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <td className="inner-td">
                        {adrDrustvo.drzava ? (
                          <>
                            <b>Država: </b>
                            {adrDrustvo.drzava}
                          </>
                        ) : null}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            ))}
            <td className="hr-divider">
              {adrUreda.length > 0
                ? adrUreda.map((adrUred, index) => (
                  <>
                    {adrUred.ulicaKbr
                      &&
                      (
                        adrUred.brPoste
                        ||
                        adrUred.nazNaselja
                      )
                      &&
                      adrUred.drzava
                      ?
                      (
                        <>
                          <table
                            key={`table${index}`}
                            style={{
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="inner-td">
                                  <b>Ulica i kbr: </b>
                                  {adrUred.ulicaKbr
                                    ? adrUred.ulicaKbr
                                    : noDataMessage}
                                </td>
                              </tr>

                              {adrUred.brPoste || adrUred.nazNaselja ? (
                                <tr>
                                  <td className="inner-td">
                                    <b>Grad: </b>
                                    {adrUred.brPoste}
                                    {adrUred.nazNaselja && " " + adrUred.nazNaselja}
                                  </td>
                                </tr>
                              ) : null}

                              {adrUred.drzava ? (
                                <>
                                  <tr>
                                    <td className="inner-td">
                                      <b>Država: </b>
                                      {adrUred.drzava}
                                    </td>
                                  </tr>
                                </>
                              ) : null}
                            </tbody>
                          </table>
                          <hr />{" "}
                        </>
                      ) : null
                    }
                  </>
                  )) : noDataMessage}
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>Kontakti</h5>

      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Kontakt</th>
          </tr>
        </thead>
        <tbody>
          {kontaktDrustva.length > 0 ? (
            kontaktDrustva.map((kontaktDrustvo, index) =>
              !kontaktDrustvo.ime &&
              !kontaktDrustvo.prezime &&
              !kontaktDrustvo.telefon &&
              !kontaktDrustvo.web &&
              !kontaktDrustvo.email ? (
                <tr key={`kontakt-drustva`}>
                  <td></td>
                </tr>
              ) : (
                <tr key={`trkontakt${index}`}>
                  <td x-ms-format-detection="none">
                    <div>
                      {kontaktDrustvo.ime ? kontaktDrustvo.ime : null}{" "}
                      {kontaktDrustvo.prezime ? kontaktDrustvo.prezime : null}
                    </div>
                    <div>
                      {kontaktDrustvo.telefon ? (
                        <>
                          <b>telefon: </b>
                          {kontaktDrustvo.telefon}
                        </>
                      ) : null}
                    </div>
                    <div>
                      {kontaktDrustvo.web ? (
                        <>
                          <b>web: </b>
                          {kontaktDrustvo.web}
                        </>
                      ) : null}
                    </div>
                    <div>
                      {kontaktDrustvo.email ? (
                        <>
                          <b>email: </b>
                          {kontaktDrustvo.email}
                        </>
                      ) : null}
                    </div>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="4"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Ovlašteni revizori koji su zaposleni u revizorskom društvu
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {ovlasteniRevizori.length > 0 ? (
            ovlasteniRevizori.map((ovlRevizor) => (
              <tr>
                <td>
                  {ovlRevizor.imeOsobe} {ovlRevizor.prezimeOsobe}
                </td>
                <td>{ovlRevizor.regBrojOsobe}</td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "osoba",
                        ovlRevizor.idOsobe,
                        ovlRevizor.vrOsobe,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Članovi uprave, upravni odbor, prokuristi</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Funkcija</th>
            <th scope="col">Poslovna adresa</th>
          </tr>
        </thead>
        <tbody>
          {clanoviUprave.length > 0 ? (
            clanoviUprave.map((clanUprave, index) => (
              <tr key={`tr-clan-uprave${index}`}>
                <td>
                  {clanUprave.ime} {clanUprave.prezime}
                  {checkIfUserIsAdmin && clanUprave.oib
                    ? " (" + clanUprave.oib + ")"
                    : null}
                </td>
                <td>
                  {clanUprave.funkcija ? clanUprave.funkcija : noDataMessage}
                </td>
                <td>
                  <table>
                    <tbody>
                      {clanUprave.ulicaKbr ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {clanUprave.ulicaKbr}
                          </td>
                        </tr>
                      ) : null}
                      {clanUprave.brPoste || clanUprave.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {clanUprave.brPoste}
                            {clanUprave.nazNaselja &&
                              " " + clanUprave.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {clanUprave.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {clanUprave.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Dioničari / članovi društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv društva / Ime i prezime</th>
            <th scope="col">Poslovna adresa</th>
          </tr>
        </thead>
        <tbody>
          {dionicari.length > 0 ? (
            dionicari.map((dionicar, index) => (
              <tr key={`tr-dionicari${index}`}>
                <td>
                  {dionicar.naziv
                    ? dionicar.naziv
                    : dionicar.ime && dionicar.prezime
                    ? dionicar.ime + " " + dionicar.prezime
                    : noDataMessage}
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {dionicar.ulicaKbr
                            ? dionicar.ulicaKbr
                            : noDataMessage}
                        </td>
                      </tr>
                      {dionicar.brPoste || dionicar.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {dionicar.brPoste}
                            {dionicar.nazNaselja && " " + dionicar.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {dionicar.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {dionicar.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Ovlašteni revizori povezani s revizorskim društvom na drugi način</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Revizorski subjekt</th>
            <th scope="col"> Funkcija</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
        {povezaniSubjekti.length > 0 ? (
          povezaniSubjekti.map((povSubjekt) => (
            <>
                {povSubjekt.funkcijaUSubjektu.map((subjekt,index)=>{
                  
                  if(index!= 0){
                    return(
                      <tr>
                        <td>{subjekt.nazivDrustva}</td>
                        <td>{subjekt.funkcija}</td>
                      </tr>
                    )
                  }
                  return (
                    <tr>
                      <td rowSpan={povSubjekt.funkcijaUSubjektu.length}>{povSubjekt.ime} {povSubjekt.prezime}</td>
                      <td>{subjekt.nazivDrustva}</td>
                      <td>{subjekt.funkcija}</td>
                      <td rowSpan={povSubjekt.funkcijaUSubjektu.length} className="ant_batn">
                        <ButtonComponent
                          disabled={povSubjekt.idOsobe === null || povSubjekt.vrOsobe === null}
                          variant="secondary"
                          onClick={(e) =>
                            props.detaljiSecondaryClicked(
                              "osoba",
                              povSubjekt.idOsobe,
                              povSubjekt.vrOsobe,
                              false
                            )
                          }
                        >
                          <ZoomInOutlined />
                        </ButtonComponent>
                     </td>
                    </tr>
                  ) 
                })}
            </>
            ))
          ) : (
            <tr>
              <td colSpan="4"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Registracija kod nadležnog tijela drugih država članica</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {registracijaNadlTijelaDrugihDrzavaCl.length > 0 ? (
            registracijaNadlTijelaDrugihDrzavaCl.map((reg, index) =>
              !reg.brReg &&
              !reg.datReg &&
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`tr-registracija${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`tr-registracija${index}`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Registracija revizorskog društva u drugoj državi članici kao subjekta za
        obavljanje revizije u trećoj zemlji
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {regUDrugojDrzaviKaoSubjektaZaObavljanjeRevizijeUTrecojZemlji.length >
          0 ? (
            regUDrugojDrzaviKaoSubjektaZaObavljanjeRevizijeUTrecojZemlji.map(
              (reg, index) =>
                !reg.brReg &&
                !reg.datReg &&
                !reg.nazTijela &&
                !reg.ulicaKbr &&
                !reg.brPoste &&
                !reg.nazNaselja ? (
                  <tr key={`tr-reg-treca-zemlja${index}`}>
                    <td colSpan="3"></td>
                  </tr>
                ) : (
                  <tr key={`tr-reg-treca-zemlja${index}`}>
                    <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                    <td>
                      <table>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>

                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}

                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </table>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                )
            )
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Nadležno tijelo države članice odgovorno za nadzor osiguranja kvalitete
        rada i nadzor ovlaštenih revizora i revizorskih društava
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
          </tr>
        </thead>
        <tbody>
          {nadleznaTijela.length > 0 ? (
            nadleznaTijela.map((nadleznoTijelo, index) =>
              !nadleznoTijelo.nazTijela &&
              !nadleznoTijelo.ulicaKbr &&
              !nadleznoTijelo.brPoste &&
              !nadleznoTijelo.nazNaselja ? (
                <tr key={`tr-nadlezna-tijela${index}`}>
                  <td colSpan="2"></td>
                </tr>
              ) : (
                <tr key={`tr-nadlezna-tijela${index}`}>
                  <td>
                    {nadleznoTijelo.nazTijela
                      ? nadleznoTijelo.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {nadleznoTijelo.ulicaKbr
                            ? nadleznoTijelo.ulicaKbr
                            : noDataMessage}
                        </td>
                      </tr>

                      {nadleznoTijelo.brPoste || nadleznoTijelo.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {nadleznoTijelo.brPoste}
                            {nadleznoTijelo.nazNaselja &&
                              " " + nadleznoTijelo.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {nadleznoTijelo.nazivDrzave ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {nadleznoTijelo.nazivDrzave}
                          </td>
                        </tr>
                      ) : null}
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Revizorske mreže / članovi mreže / povezana društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv i sjedište mreže</th>
            <th scope="col">Adrese članova mreže</th>
            <th scope="col">Povezana društva i adrese</th>
            <th scope="col">
              Internetska stranica na kojoj se navedeni podaci mogu provjeriti
            </th>
          </tr>
        </thead>
        <tbody>
          {!mreza.nazMreze &&
          !mreza.ulicaKbr &&
          !mreza.brPoste &&
          !mreza.nazNaselja &&
          !clanMreze.length > 0 ? (
            <tr>
              <td colSpan="4"></td>
            </tr>
          ) : (
            <tr>
              {!mreza.nazMreze &&
              !mreza.ulicaKbr &&
              !mreza.brPoste &&
              !mreza.nazNaselja ? (
                <td></td>
              ) : (
                <>
                  <td>
                    <table>
                      <tr>
                        <td className="inner-td">
                          <b>Naziv mreže: </b>
                          {mreza.nazMreze ? mreza.nazMreze : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {mreza.ulicaKbr ? mreza.ulicaKbr : noDataMessage}
                        </td>
                      </tr>

                      {mreza.brPoste || mreza.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {mreza.brPoste}
                            {mreza.nazNaselja && " " + mreza.nazNaselja}
                          </td>
                        </tr>
                      ) : null}

                      {mreza.nazDrzave ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {mreza.nazDrzave}
                          </td>
                        </tr>
                      ) : null}
                    </table>
                  </td>
                </>
              )}
              <td className="hr-divider">
                {clanoviMreze.length > 0
                  ? clanoviMreze.map((clanMreza) => (
                      <>
                        <table>
                          <tr>
                            <td className="inner-td">
                              <b>Naziv mreže: </b>
                              {clanMreza.nazMreze
                                ? clanMreza.nazMreze
                                : noDataMessage}
                            </td>
                          </tr>
                          <tr>
                            <td className="inner-td">
                              <b>Ulica i kbr: </b>
                              {clanMreza.ulicaKbr
                                ? clanMreza.ulicaKbr
                                : noDataMessage}
                            </td>
                          </tr>
                          {clanMreza.brPoste || clanMreza.nazNaselja ? (
                            <tr>
                              <td className="inner-td">
                                <b>Grad: </b>
                                {clanMreza.brPoste}
                                {clanMreza.nazNaselja &&
                                  " " + clanMreza.nazNaselja}
                              </td>
                            </tr>
                          ) : null}
                          {clanMreza.nazDrzave ? (
                            <tr>
                              <td className="inner-td">
                                <b>Država: </b>
                                {clanMreza.nazDrzave}
                              </td>
                            </tr>
                          ) : null}
                        </table>{" "}
                        <hr />
                      </>
                    ))
                  : null}
              </td>
              <td className="hr-divider">
                {povezanaDrustva.length > 0
                  ? povezanaDrustva.map((povezanoDrustvo) => (
                      <>
                        <table>
                          <tr>
                            <td className="inner-td">
                              <b>Naziv društva: </b>
                              {povezanoDrustvo.nazDrustva
                                ? povezanoDrustvo.nazDrustva
                                : noDataMessage}
                            </td>
                          </tr>
                          <tr>
                            <td className="inner-td">
                              <b>Ulica i kbr: </b>
                              {povezanoDrustvo.ulicaKbr
                                ? povezanoDrustvo.ulicaKbr
                                : noDataMessage}
                            </td>
                          </tr>
                          {povezanoDrustvo.brPoste ||
                          povezanoDrustvo.nazNaselja ? (
                            <tr>
                              <td className="inner-td">
                                <b>Grad: </b>
                                {povezanoDrustvo.brPoste}
                                {povezanoDrustvo.nazNaselja &&
                                  " " + povezanoDrustvo.nazNaselja}
                              </td>
                            </tr>
                          ) : null}
                          {povezanoDrustvo.nazDrzave ? (
                            <tr>
                              <td className="inner-td">
                                <b>Država: </b>
                                {povezanoDrustvo.nazDrzave}
                              </td>
                            </tr>
                          ) : null}
                        </table>
                        <hr />
                      </>
                    ))
                  : null}
              </td>
              <td className="hr-divider">
                {clanMreze.map((cm) => (
                  <>
                    <a href={"http://" + cm.web} target="_blank">
                      {cm.web}
                    </a>
                    <hr />
                  </>
                ))}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : null}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
              <th scope="col">Datum brisanja</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {mjere.length ? (
            mjere.map((mjera) => (
              <tr>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentDrustvo(e, mjera.idMjereDrustva)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>

                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tr>
                      <td className="inner-td">
                        <b>Broj rješenja: </b>
                        {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                      </td>
                    </tr>
                    <tr>
                      <td className="inner-td">
                        <b>Datum rješenja: </b>
                        {mjera.datRjesenja ? mjera.datRjesenja : noDataMessage}
                      </td>
                    </tr>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    {mjera.napomena2 ? (
                      <tr>
                        <td className="inner-td">
                          <b>Napomena: </b>
                          {mjera.napomena2}
                        </td>
                      </tr>
                    ) : null}
                  </table>
                </td>
                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  {mjera.napomena3 ? (
                    <table>
                      <tr>
                        <td className="inner-td">
                          <b>Napomena: </b>
                          {mjera.napomena3}
                        </td>
                      </tr>
                    </table>
                  ) : null}
                </td>
                {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default RevizorskaDrustvaDetaljiTable;
